import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const navigate = useNavigate();

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门赛事分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            覆盖全球主流体育项目，一站在手尽享全部精彩
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <div
              key={cat.id}
              onClick={() => handleCategoryClick(cat.slug)}
              className="group bg-background-100 rounded-xl p-5 md:p-6 cursor-pointer transition-all duration-200 hover:bg-primary-50 border border-transparent hover:border-primary-200"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-3 md:mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <h4 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-1 tracking-wide">
                {cat.name}
              </h4>
              <p className="text-foreground-500 text-xs">
                {cat.articleCount} 篇文章
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}